import { IidPrefix } from './app/archive/shared/interfaces/IidPrefix';
//import * as objectID from 'bson-objectid';
const objectID = require('bson-objectid');


export class ObjectId {
  static createObjectId<S extends IidPrefix>(id: S): string {
    const newObjectId = new objectID();
    return id.idPrefix + '_' + newObjectId.toHexString();
  }

  static createObjectIdAlt<S extends IidPrefix>(type: new () => S): string {
    return new type().idPrefix + '_' + new objectID().toHexString();
  }
}
